import DocumentCreate from './DocumentCreate';
import DocumentEdit from './DocumentEdit';
import DocumentList from './DocumentList';
import DocumentShow from './DocumentShow';

const documents = {
  list: DocumentList,
  show: DocumentShow,
  create: DocumentCreate,
  edit: DocumentEdit,
};

export default documents;
export { documents };
